import React from 'react';
import { connect } from "react-redux";
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';

export class NaplatniUredaj extends React.Component{
    state={
        pickedDevice: [],
        oznNapUredList: [],
        
    }


    setNazNapUred = async (data) => {
        this.props.devices.filter(devices => devices.label === data.value).map(filteredData => (
            this.setState({
                pickedDevice: filteredData
            })
        ))
    }
    
    render(){ 
        const {description, label, ecommerce } = this.state.pickedDevice
        
        let listOption = []
        this.props.devices.map((data) => (
           listOption.push({label: data.description, value: data.label})
        ))
    
        return (
            <div style={{padding: "40px"}}>
                <div className="form-group row">
                    <label htmlFor="nazNapUred" className="col-sm-4 col-form-label">Odaberi naplatni uređaj</label>
                    <div className="col-sm-4">
                        <Dropdown 
                            options={listOption} 
                            onChange={this.setNazNapUred} 
                            //value={this.state.nazNapUred} 
                            value={description ? description: ""}
                            placeholder="Izaberi" 
                        />                      
                    </div> 
                </div>
                
                <br/>
           
                  
                <form>
                    <div className="form-group row">
                        <label htmlFor="NazPosProst" className="col-sm-4 col-form-label">Naziv Naplatnog Uređaja</label>
                        <div className="col-sm-4">
                            <input
                                disabled
                                type="text"
                                //value={this.state.nazNapUred}
                                value={description ? description: ""}
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label htmlFor="oznPosProst" className="col-sm-4 col-form-label">Oznaka Naplatnog Uređaja</label>
                        <div className="col-sm-4">
                            <input  
                                disabled                       
                                type="text"
                                //value={this.state.oznNapUred}
                                value={label ? label: ""}
                            />
                        </div>
                    </div>
                    <div className="form-group row" style={{ alignItems: 'center' }}>
                    <label htmlFor="E-commerce" className="col-sm-4 col-form-label">E-commerce</label>
                    <div className="col-sm-4">
                        <label className="form-check-label" htmlFor="ecommerce">
                            <input  
                                disabled                       
                                type="checkbox"
                                checked={ecommerce}
                            />
                            &nbsp;&nbsp; e-commerce
                        </label>
                    </div>
                </div>   
                    
                {/*}
                    <div className="form-group row">
                        <label htmlFor="posProstor" className="col-sm-4 col-form-label">Odaberi poslovni prostor</label>
                        <div className="col-sm-4">
                            <Dropdown 
                                options={posProstor} 
                                onChange={changedProstor} 
                                //value={defaultOption} 
                                placeholder="Izaberi" 
                            />
                        </div> 
                
                    </div>
                   
                <div className="form-group row justify-content-md-center">
                    <div className="col-sm-2">
                        <button className="btn btn-info" style={{padding:"10px"}}>Save</button>
                    </div>
                </div> 
                */}
                
                </form>
            </div>
        )
    }
}


const mapStateToProps = state => {
    return {
        devices : state.client.devices
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(NaplatniUredaj);

